import React from 'react'
import styled from 'styled-components'
import tw from 'twin.macro'
import LazyImage, { setPlaceholderImage } from '../LazyImage'

const CenteredImage = ({ slice }) => {
  const doc = slice.primary
  const { width, height } = doc.image.dimensions

  return (
    <Root>
      <LazyImage
        placeholder={setPlaceholderImage(width, height)}
        src={doc.image.url}
        alt={doc.image.alt}
        width={width}
      />
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${tw`mb-16`}
`;

export default CenteredImage